import { getCSRCookieData } from './getCSRCookieData'

const getCSRAuthToken = () => {
  if (typeof window === 'undefined') return null
  return getCSRCookieData('_IL-token') || localStorage.getItem('token')
}

export default getCSRAuthToken
